import { useTranslation } from "react-i18next";
import Navigation from "../app/components/NavigationSPA";
import { SERVER_REGION } from "../i18n";

interface VideoCard {
  title: string;
  titleZh: string;
  description: string;
  descriptionZh: string;
  youtubeId: string;
  cnVideoEn: string;
  cnVideoZh: string;
}

const VIDEOS: VideoCard[] = [
  {
    title: "SmartProbe Set Up Tutorial",
    titleZh: "SmartProbe 设置教程",
    description: "Learn how to set up your SmartProbe device",
    descriptionZh: "了解如何设置您的 SmartProbe 设备",
    youtubeId: "WFRFPraDB3I",
    cnVideoEn: "/videos/SetUp Tutorial CN.mp4",
    cnVideoZh: "/videos/SetUp Tutorial CN.mp4",
  },
  {
    title: "SmartProbe Mobile App Walkthrough",
    titleZh: "SmartProbe 移动应用演示",
    description: "Navigate the SmartProbe mobile application",
    descriptionZh: "了解如何使用 SmartProbe 移动应用程序",
    youtubeId: "Ic7bxvvWn4w",
    cnVideoEn: "/videos/mobile-app-en.mp4",
    cnVideoZh: "/videos/SmartProbe Mobile App Walkthrough_ZH.mp4",
  },
  {
    title: "SmartProbe Website Walkthrough",
    titleZh: "SmartProbe 网站演示",
    description: "Explore the SmartProbe website application",
    descriptionZh: "探索 SmartProbe 网站应用程序",
    youtubeId: "U0ulR-WTnwk",
    cnVideoEn: "/videos/website-walkthrough-en.mp4",
    cnVideoZh: "/videos/SmartProbe Website Walkthrough_ZH.mp4",
  },
];

const isCN = SERVER_REGION === "CN";

export default function TutorialVideosPage() {
  const { i18n } = useTranslation();
  const isZh = i18n.language === "zh";

  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation />

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          {/* Page header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">
              {isZh ? "教程视频" : "Tutorial Videos"}
            </h1>
            <p className="text-gray-500 mt-1">
              {isZh
                ? "通过我们的综合视频教程学习如何使用 SmartProbe"
                : "Learn how to use SmartProbe with our comprehensive video tutorials"}
            </p>
          </div>

          {/* Video grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VIDEOS.map((video) => {
              const title = isZh ? video.titleZh : video.title;
              const description = isZh ? video.descriptionZh : video.description;
              const cnSrc = `${encodeURI(isZh ? video.cnVideoZh : video.cnVideoEn)}?v=20260817-cn`;

              return (
                <div
                  key={video.youtubeId}
                  className="bg-white rounded-lg shadow overflow-hidden flex flex-col"
                >
                  {isCN ? (
                    /* Self-hosted video for CN region */
                    <video
                      key={cnSrc}
                      className="w-full"
                      src={cnSrc}
                      controls
                      preload="metadata"
                      style={{ aspectRatio: "16/9" }}
                    >
                      <p className="p-4 text-sm text-gray-500">
                        {isZh
                          ? "您的浏览器不支持视频播放。"
                          : "Your browser does not support video playback."}
                      </p>
                    </video>
                  ) : (
                    /* YouTube embed for Global region */
                    <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                      <iframe
                        className="absolute inset-0 w-full h-full"
                        src={`https://www.youtube.com/embed/${video.youtubeId}`}
                        title={title}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                    </div>
                  )}

                  {/* Card info */}
                  <div className="p-4 flex flex-col flex-1">
                    <h2 className="text-base font-bold text-gray-900">{title}</h2>
                    <p className="text-sm text-gray-500 mt-1">{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </main>
    </div>
  );
}
